import { Injectable } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ExercicioService, OrgaoService, GlobalService, FuncaoService, Relatorio } from 'eddydata-lib';
import { FichaExtraService } from 'contabil-lib';

@Injectable({
  providedIn: 'root'
})
export class BalanceteExtraService {

  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected fichaService: FichaExtraService,
    protected exercicioService: ExercicioService,
    protected orgaoService: OrgaoService,
    protected globalService: GlobalService,
    protected funcaoService: FuncaoService
  ) { }

  async montarBalanceteExtra(mes: number, exercicioId: number, orgaos: number[], login: any) {
    const parametros: {} = {};
    if (mes) {
      parametros['mes'] = mes;
    }
    if (exercicioId) {
      parametros['ano'] = exercicioId;
    }
    parametros['orgaos'] = orgaos.join();
    parametros['especie'] = 'E'
    const ex = await this.exercicioService.obterId(exercicioId).toPromise();
    this.fichaService.balancete(parametros)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(dados => {
        Relatorio.imprimirPersonalizado('REFERÊNCIA: ' +
          this.globalService.obterDataBR().monthNames[mes - 1].toLocaleUpperCase() + '/' + ex.ano
          , login.usuario.nome,
          login.orgao.nome, login.brasao,
          this.balanceteDespesaConteudo(dados),
          'portrait', 'Balancete Extra Orçamentario',
          {
            linhas: {
              hLineWidth(i, node) {
                return 1;
              },
              vLineWidth(i) {
                return 1;
              },
              hLineColor(i) {
                return 'black';
              },
              paddingLeft(i) {
                return 3;
              },
              paddingRight(i, node) {
                return 3;
              }
            }
          });
      });
  }

  balanceteDespesaConteudo(dados: any[]): {}[] {
    const registros: {}[] = [
      [{
        text: 'DEMONSTRAÇÃO DA RECEITA E DESPESA EXTRA-ORÇAMENTÁRIA',
        colSpan: 9, alignment: 'center', bold: true, fontSize: 11
      },
        '', '', '', '', '', '', '', ''],
      [
        { text: 'FICHA', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: 'DESCRIÇÃO', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: 'ANTERIOR', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: 'CANCELADO', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 },
        { text: 'RECEITAS', alignment: 'center', colSpan: 2, bold: true, fontSize: 7 },
        { text: '' },
        { text: 'DESPESAS', alignment: 'center', colSpan: 2, bold: true, fontSize: 7 },
        { text: '' },
        { text: 'SALDO', alignment: 'center', rowSpan: 2, bold: true, fontSize: 7 }
      ],
      ['', '', '', '',
        { text: 'DO MÊS', alignment: 'center', bold: true, fontSize: 7 },
        { text: 'ACUMULADO', alignment: 'center', bold: true },
        { text: 'DO MÊS', alignment: 'center', bold: true, fontSize: 7 },
        { text: 'ACUMULADO', alignment: 'center', bold: true, fontSize: 7 }, '']
    ];
    const executora = {};
    let totalAnterior = 0.00;
    let totalCancelado = 0.00;
    let totalReceitaMes = 0.00;
    let totalReceitaAcumulado = 0.00;
    let totalDespesaMes = 0.00;
    let totalDespesaAcumulado = 0.00;
    let totalSaldo = 0.00;
    for (const registro of dados) {

      const grupo = String(registro['p_codigo']).substr(0, 1);
      if (!executora['grupo'] || executora['grupo'] !== grupo) {
        if (executora['grupo']) {
          registros.push(this.retornarLinhaSomaExecutora(executora));
        }
        executora['nome'] = registro['fh_nome'];
        executora['grupo'] = grupo;
        executora['orcado'] = 0.00;
        executora['anterior'] = 0.00;
        executora['cancelado'] = 0.00;
        executora['receita_mes'] = 0.00;
        executora['receita_acumulado'] = 0.00;
        executora['despesa_mes'] = 0.00;
        executora['despesa_acumulado'] = 0.00;
        executora['saldo'] = 0.00;

        registros.push([
          {
            text: `${grupo === '1' ? 'ATIVO' : grupo === '2' ? 'PASSIVO' : 'RESTOS A PAGAR'}`, colSpan: 9,
            bold: true, fontSize: 8
          },
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          ''
        ]);
      }
      const anterior: number = registro['anterior'];
      const cancelado: number = registro['cancelado'];
      const despesaMes: number = registro['despesa_mes'];
      const despesaAcumulado: number = registro['despesa_acumulado'];
      const receitaMes: number = registro['receita_mes'];
      const receitaAcumulado: number = registro['receita_acumulado'];
      const saldo = +receitaAcumulado - +despesaAcumulado;
      executora['anterior'] += +anterior;
      executora['cancelado'] += +cancelado;
      executora['despesa_mes'] += +despesaMes;
      executora['despesa_acumulado'] += +despesaAcumulado;
      executora['receita_mes'] += +receitaMes;
      executora['receita_acumulado'] += +receitaAcumulado;
      executora['saldo'] += +saldo;
      totalAnterior += +anterior;
      totalCancelado += +cancelado;
      totalDespesaMes += +despesaMes;
      totalDespesaAcumulado += +despesaAcumulado;
      totalReceitaMes += +receitaMes;
      totalReceitaAcumulado += +receitaAcumulado;
      totalSaldo += +saldo;

      registros.push([
        {
          text: this.funcaoService.strZero(registro['fh_numero'], 3),
          border: [true, false, true, false], alignment: 'center', fontSize: 7
        },
        {
          text: registro['p_codigo'] ?
            this.funcaoService.mascarar('#.#.#.#.#.##.##', registro['p_codigo']) + ' ' + registro['fh_nome'] : registro['fh_nome'],
          border: [true, false, true, false], fontSize: 7
        },
        { text: this.funcaoService.convertToBrNumber(anterior), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(cancelado), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(receitaMes), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        {
          text: this.funcaoService.convertToBrNumber(receitaAcumulado), alignment: 'right',
          border: [true, false, true, false], fontSize: 7
        },
        { text: this.funcaoService.convertToBrNumber(despesaMes), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
        {
          text: this.funcaoService.convertToBrNumber(despesaAcumulado), alignment: 'right',
          border: [true, false, true, false], fontSize: 7
        },
        { text: this.funcaoService.convertToBrNumber(saldo), alignment: 'right', border: [true, false, true, false], fontSize: 7 },
      ]);
    }
    if (executora['grupo']) {
      registros.push(this.retornarLinhaSomaExecutora(executora));
      registros.push([
        {
          text: 'TOTAL GERAL:', colSpan: 2,
          bold: true, fontSize: 7
        },
        '',
        { text: this.funcaoService.convertToBrNumber(totalAnterior), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalCancelado), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalReceitaMes), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalReceitaAcumulado), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalDespesaMes), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalDespesaAcumulado), bold: true, alignment: 'right', fontSize: 7 },
        { text: this.funcaoService.convertToBrNumber(totalSaldo), bold: true, alignment: 'right', fontSize: 7 },
      ]);
    }
    return [{
      layout: 'linhas',
      table: {
        // headers are automatically repeated if the table spans over multiple pages
        // you can declare how many rows should be treated as headers
        dontBreakRows: true,
        headerRows: 3,
        widths: ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
        body: registros
      }
    }];
  }

  retornarLinhaSomaExecutora(executora: {}) {
    return [
      {
        text: 'SOMA', colSpan: 2,
        bold: true, fontSize: 7
      },
      '',
      { text: this.funcaoService.convertToBrNumber(executora['anterior']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(executora['cancelado']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(executora['receita_mes']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(executora['receita_acumulado']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(executora['despesa_mes']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(executora['despesa_acumulado']), bold: true, alignment: 'right', fontSize: 7 },
      { text: this.funcaoService.convertToBrNumber(executora['saldo']), bold: true, alignment: 'right', fontSize: 7 }
    ];
  }

}
